/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-29 17:21:38
 * @LastEditors: Json Chen
 * @LastEditTime: 2022-06-14 17:43:09
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelLegal/TermsAndConditionEditor/index.tsx
 */
import Layout from '@/src/layout/EditorPageLayout/EditorCollapsePageLayout';
import { LinkModuleType } from '@/src/types/common/linkType';
import React from 'react';
import { useParams } from 'react-router-dom';
import SalesChannelHOC from 'src/constrains/SalesChannelHOC/SalesChannelHOC';
import { EnumMultiLanguageType } from 'src/constrains/SalesChannelMultiLanguageSelect';
// import TopRight from '@/src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
// import TopLeft from '@/src/layout/EditorPageLayout/GoBackAndBreadCrumb/GoBackAndBreadCrumb';
import { deleteTC } from 'src/request/salesChannel/legal';
import HOC, { EnumPage } from '../Components/EditorHOC';
import { tacPermissions } from '../Components/hooks/permission';
import CloneBtn from './CloneButton';
import Content from './Content';
import LegalSetting from './LegalSetting';
import PageSetting from './PageSetting';
import RouteBlock from './RouteBlock';
import {
  fetchTermsAndCondition,
  getHasModified,
  getLastModified,
  getLoaded,
  getPageName,
  getState,
  getUuid,
  resetData,
  submitTermsAndCondition,
  updateEssentialData,
  validation,
} from './slice';
import { convertDataFromReduxToServer } from './tools';

const TC = (props) => {
  const params: any = useParams();
  const uuid = params.uuid;
  const {
    // history: _h,
    // dispatch: _d,
    // params: _p,

    topLeft,
    topRight,
    hasModified,
    loaded,
    isPrimary,
  } = props;

  //const { TcUuid, uuid } = _p;

  // React.useEffect(() => {
  //   const _uuid = TcUuid;
  //   if (_uuid === NEW) {
  //     _d(updateEssentialData({ salesChannelUuid: uuid }));
  //   } else {
  //     _d(fetchTermsAndCondition({ uuid: _uuid }));
  //   }

  //   return () => {
  //     _d(resetData());
  //   };
  // }, []);
  const ele = React.useMemo(() => {
    if (isPrimary) {
      return [
        { element: PageSetting, id: 'PageSetting' },
        { element: LegalSetting, id: 'LegalSetting' },
        {
          element: Content,
          id: 'Content',
          p: {
            linkSet: {
              scopeVariables: {
                SalesChannel: uuid,
              },
              linkTypeFilter: [
                LinkModuleType.None,
                LinkModuleType.LinkLibrary,
                LinkModuleType.LegalPage,
              ],
            },
          },
        },
      ];
    } else {
      return [
        { element: CloneBtn, id: 'CloneBtn' },
        { element: PageSetting, id: 'PageSetting' },
        {
          element: Content,
          id: 'Content',
          p: {
            linkSet: {
              scopeVariables: {
                SalesChannel: uuid,
              },
              linkTypeFilter: [
                LinkModuleType.None,
                LinkModuleType.LinkLibrary,
                LinkModuleType.LegalPage,
              ],
            },
          },
        },
      ];
    }
  }, [isPrimary]);
  const Child = React.useMemo(() => {
    if (loaded) {
      return ele;
    } else {
      return [];
    }
  }, [loaded, isPrimary]);

  return (
    <React.Fragment>
      <RouteBlock hasModified={hasModified} />
      <Layout topLeft={topLeft} topRight={topRight} elements={Child} />
    </React.Fragment>
  );
};
export default SalesChannelHOC(
  HOC(TC, {
    getHasModified,
    getName: getPageName,
    _key: EnumPage.termsAndCondition,
    validation,
    getState,
    convertDataFromReduxToServer,
    submit: submitTermsAndCondition,
    deleteFunction: deleteTC,
    getLoaded,
    getUuid,
    getData: fetchTermsAndCondition,
    updateEssentialData,
    resetData,
    getLastModified,
    getPermissions: tacPermissions,
  }),
  { type: EnumMultiLanguageType.SalesChannelTermsCondition },
);
